import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {DialogButtonType} from "./ConfirmationDialog.model";

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})

export class ConfirmationDialogComponent {

  dialogButtonType = DialogButtonType

  constructor(@Inject(MAT_DIALOG_DATA) public data: { confirmMessage: string, confirmButtonText: string, dialogType: string }, private matDialogRef: MatDialogRef<ConfirmationDialogComponent>) {
  }

  public close(value) {
    this.matDialogRef.close(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/confirmation-dialog/confirmation-dialog.component.ts